// extracted by mini-css-extract-plugin
export default {"wrapper":"carImageSmall_wrapper__CuVVa","img":"carImageSmall_img__9GA0N"};